<template lang="pug">
div(v-on-clickaway="hideTooltip" :class="{relative:!isFullWidth}")
    div(v-on="tooltipMode")
        slot
    transition(name="fade")
        div(
            class="tooltip-wrapper absolute"
            :class="[cssClasses, { 'w-full' : isFullWidth }]"
        )
            div(
                v-if="isVisible"
                class="tooltip relative text-left text-gray-darker py-3 px-3 leading-snug bg-white border border-solid border-gray-light rounded shadow font-normal normal-case z-50"
                :class="[cssClasses, { 'w-64' : !isFullWidth }]"
            )
                slot(name="text")
                    span(v-html="text")
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'

export default {
    directives: {
        onClickaway,
    },
    props: {
        text: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'click',
            validator: (value) => {
                return ['click', 'hover'].includes(value)
            },
        },
        hoverDelay: {
            type: Number,
            default: 0,
        },
        isFullWidth: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            default: 'center',
            validator: (value) => {
                return ['center', 'left', 'right'].includes(value)
            },
        },
    },
    data() {
        return {
            isVisible: false,
        }
    },
    computed: {
        tooltipMode() {
            if (this.mode === 'hover')
                return { mouseenter: this.showTooltip, mouseleave: this.hideTooltip }
            return { click: this.toggleTooltip }
        },
        cssClasses() {
            const classes = []

            if (this.align === 'right') classes.push('right')
            else if (this.align === 'left') classes.push('left')
            else if (this.align === 'center') classes.push('center')

            return classes
        },
    },
    methods: {
        showTooltip() {
            this.timeoutId = setTimeout(() => {
                this.isVisible = true
            }, this.hoverDelay)
        },
        hideTooltip() {
            clearTimeout(this.timeoutId)
            this.isVisible = false
        },
        toggleTooltip() {
            this.isVisible = !this.isVisible
        },
    },
}
</script>

<style lang="stylus" scoped>
.tooltip-wrapper
    bottom calc(100% + 10px)
    &.center
        left: 50%
    &.right
        right 0
.tooltip
    &:after
        content ''
        width 15px
        height 15px
        display block
        background-color theme('colors.white')
        border solid theme('colors.gray.light')
        border-width 1px 1px 0 0
        transform: rotate(135deg)
        position absolute
        bottom -8px
        margin auto
        left 0
        right 0
    &.center
        left -50%
    &.right:after
        right 15%
        left auto
    &.left
        left calc(-15%)
    &.left:after
        left 15%
        right auto
</style>
